var _defineProperty = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/defineProperty.js").default;
var _CN, _JP;
module.exports = {
  messages: {
    CN: (_CN = {
      home: {
        name: '首页'
      },
      design: {
        name: '店铺装修',
        home: {
          name: '页面装修'
        }
      },
      affiliate: {
        name: '分销联盟',
        brokerage: {
          name: '佣金规则'
        },
        databoard: {
          name: '数据看板'
        },
        distribution: {
          name: '分销员管理'
        },
        settlementmanager: {
          name: '结算管理',
          settlement: {
            name: '结算管理'
          },
          order: {
            name: '订单明细'
          }
        },
        poster: {
          name: '海报规约'
        }
      },
      systemsetting: {
        name: '系统设置',
        holidayset: {
          name: '假期设置'
        },
        basicsetting: {
          name: '基础设置',
          socialLogin: {
            columns: {
              thirdPlatforms: '第三方平台',
              messageNotify: '消息通知'
            },
            'wxParams1': '用于跨平台统一账号,PC端微信扫描登录',
            'wxParams2': '用于消息通知,微信客户端内的登录',
            wxParams3: '用于APP内微信登录',
            notify: '通知',
            edit: '编辑',
            decp: '可以进行拖动操作修改排序和序号，以影响展示顺序。',
            wx: '微信',
            qq: 'QQ',
            wb: '新浪微博',
            fb: 'FaceBook',
            line: 'Line',
            wxName1: 'PC网站应用',
            wxName2: '海外微信公众号',
            wxName3: '国内微信公众号',
            wxName4: '微信移动应用',
            lineRule1: '请输入Channel ID',
            lineRule2: '请输入Channel Secret',
            lineMessage: '若要打开Line消息通知，请填写Channel access token',
            wxRule1: '请输入App ID',
            wxRule2: '请输入Secret',
            wbRule1: '请输入App Key',
            wbRule2: '请输入App Serect',
            copy: '复制',
            open: '开启',
            socialLogin: '社会化登录',
            look: '查看',
            link: '链接'
          }
        },
        deliveryChannelManagement: {
          name: '发货渠道管理'
        },
        accountList: {
          name: '账号列表'
        }
      },
      freightmanager: {
        name: '配送管理'
      },
      feesetting: {
        name: '货到付款手续费'
      },
      sendtypesetting: {
        name: '运输方式设置'
      },
      marketing: {
        name: '营销管理'
      },
      cardrecommend: {
        name: '购物车推荐'
      },
      productList: {
        name: '商品列表'
      },
      producDetail: {
        name: '商品详情'
      },
      orderList: {
        name: "注文リスト"
      },
      orderDetail: {
        name: "订单详情"
      },
      orderDetail2: {
        name: "伝票詳細"
      },
      aftersaleslist: {
        name: "退换货列表"
      },
      articlemanagement: {
        name: "文章管理",
        article: {
          name: "文章列表"
        },
        addArticle: {
          name: "新建文章"
        },
        editArticle: {
          name: "编辑文章"
        }
      },
      "public.public": '公共',
      'public.copyPromp': '确定要复制吗？',
      "publicuse.new": "新建",
      "publicuse.chtypeface": "简体",
      "publicuse.type": "类型",
      "publicuse.norestrictions": "不限制",
      "publicuse.status": "状态",
      "publicuse.updatetime": "更新时间",
      "publicuse.action": "操作",
      "publicuse.edit": "编辑",
      "publicuse.delete": "删除",
      "publicuse.suerdelete": "确定要删除吗？",
      "publicuse.onshelf": "上线",
      "publicuse.offshelf": "下线",
      "publicuse.more": "更多",
      "publicuse.pleaseinput": "请输入",
      "publicuse.inquire": "查询",
      "publicuse.pleaseselect": "请选择",
      "publicuse.createdtime": "创建时间",
      "publicuse.putaway": "收起",
      "publicuse.unfold": "展开",
      "publicuse.translate": "翻訳",
      "publicuse.day": "天",
      "publicuse.goodsname": "商品名称",
      "publicuse.goodsno": "商品编号",
      "publicuse.pricetax": "售价（含税）",
      "publicuse.add": "添加",
      "publicuse.addSuccess": "新建成功",
      "publicuse.stock": "库存",
      "publicuse.enable": "启用",
      "publicuse.disabled": "停用",
      "publicuse.no": "否",
      "publicuse.yes": "是",
      "publicuse.starttime": "开始时间",
      "publicuse.endtime": "结束时间",
      "publicuse.save": "保存",
      "publicuse.jpmoney": "円",
      "publicuse.stockQuantity": "库存数量",
      "publicuse.pleaseaddgoods": "请添加商品",
      "publicuse.cancel": "取消",
      "publicuse.determine": "确定",
      "publicuse.fullcourt": "全部商品",
      "publicuse.bycategory": "指定分类参加",
      "publicuse.byitem": "指定商品参加",
      "publicuse.noparticipation": "指定商品不参加",
      "publicuse.classificationname": "分类名称",
      'publicuse.serialnumber': '序号',
      'publicuse.icon': '图标',
      'publicuse.name': '名称',
      'public.productName': '商品名称',
      'public.enterPlease': '请输入',
      'public.productNo': '商品编号',
      'public.productCategory': '商品分类',
      'public.skuNo': 'SKU编号',
      'public.sellPrice': '售价',
      'public.pleaseSelect': '请选择',
      'public.Add': '添加',
      'public.save': '保存',
      'public.no': '否',
      'public.yes': '是',
      'public.saveSuccessfully': '保存成功',
      'public.add': '新建',
      'public.confirmPrompt': '确定要修改吗？',
      'public.sureStop': '确定要停用吗？',
      'public.sureEnable': '确定要启用吗？',
      'public.deletePromp': '确定要删除吗？'
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, "public.copyPromp", '确定要复制吗？'), 'public.copy', '复制'), 'public.confirm', '确定'), 'public.cancel', '取消'), 'public.cancelSuccessfully', '取消成功'), 'public.updateSuccessfully', '更新成功'), 'public.changeSuccessfully', '修改成功'), 'public.deleteSuccessfully', '删除成功'), 'public.addSuccessfully', '新建成功'), 'public.copySuccessfully', '复制成功'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, 'public.status', '状态'), 'public.updateTime', '更新时间'), 'public.operation', '操作'), 'public.enable', '启用'), 'public.disable', '停用'), 'public.edit', '编辑'), 'public.delete', '删除'), 'public.uploadPicture', '上传图片'), 'public.picture', '图片'), 'public.upload', '上传'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, 'public.japanBrackets', '（日文）'), 'public.simpleWordBrackets', '（简体）'), 'public.traditionalBrackets', '（繁体）'), 'public.pictureType', '只能上传JPG或PNG类型的图片'), 'public.pictureMax', '上传图片不能大于{uploadLimit}MB'), 'public.uploadPictureProp', '请上传图片'), 'public.translate', '翻译'), 'public.reminder', '温馨提示'), 'public.tip', '提示'), 'public.total', '总条数'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, "public.disabledprop", '确定要停用吗？'), 'public.productInfo', '商品信息'), 'public.customerInfo', '客户信息'), "public.havetax", "（含税）"), 'public.importGoods', '导入商品'), 'public.remove', '移除'), 'public.sureremove', '确认移除吗？'), 'public.downloadTemplate', '下载模板'), 'public.lookData', '查看'), 'public.selected', '已选'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, 'public.term', '项'), 'public.batchoperation', '批量操作'), 'public.batchremove', '批量移除'), 'public.checktheitem', '勾选商品'), 'public.currentpage', '当前页'), 'public.allpage', '全部页'), 'public.syn', '同步'), 'public.nosyn', '不同步'), 'public.cancelremoval', '取消移除'), 'public.removalsucceeded', '移除成功'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, 'public.allproduct', '全部商品'), 'public.yesproduct', '指定商品参加'), 'public.noproduct', '指定商品不参加'), "public.invalid", "失效"), "public.sureinvalid", "确认要失效该商品吗？"), 'public.normal', '正常'), 'public.limitedsettings', '限购设置'), 'public.batchinvalid', '批量失效'), 'public.batchnumber', '批量设置参与件数'), 'public.discount', '折扣'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, 'public.more', '更多'), 'public.orderStatus1', '待支付'), 'public.orderStatus2', '待处理'), 'public.orderStatus3', '发货准备'), 'public.orderStatus4', '拣货中'), 'public.orderStatus5', '已发货'), 'public.orderStatus6', '已完成'), 'public.orderStatus7', '已取消'), 'public.orderStatus8', '已返品'), 'public.orderStatus9', '处理中'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, 'public.expressStatus0', '待揽件'), 'public.expressStatus1', '已揽件'), 'public.expressStatus2', '配送中'), 'public.expressStatus3', '已收货'), 'public.expressStatus4', '重新配送'), 'public.expressStatus5', '出现问题'), 'public.orderStatus99', '已处理'), 'public.arriveItem0', '无指定'), 'public.arriveItem1', '午前'), 'public.arriveItem2', '14:00~16:00'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, 'public.arriveItem3', '16:00~18:00'), 'public.arriveItem4', '18:00~20:00'), 'public.arriveItem5', '19:00~21:00'), 'public.exportpromptone', '导入模板只能是 xls、xlsx格式!'), 'public.exportprompytwo', '导入模板大小不能超过 10MB!'), 'public.importfiledproduct', '导入失败商品列表'), 'public.failurereason', '失败原因'), 'public.notontheshelf', '未上架'), 'public.deleted', '已删除'), 'public.disposals', '特卖品'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, 'public.nonexistent', '不存在'), 'public.overSell', '终卖'), 'public.overSellPromp', '确定要终卖吗？'), 'public.success', '成功'), 'public.fail', '失败'), 'public.addfail', '新建失败，请联系管理员！'), 'public.individual', '个'), 'public.importfail', '导入失败，请联系管理员！'), 'public.specialoffer', '特价'), 'public.multiple', '倍数'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, 'public.previousstep', '上一步'), 'public.nextstep', '下一步'), 'public.addsuccee', '完成'), 'public.newagain', '再次新建'), 'public.returntolist', '返回列表'), 'public.pleaseCropThePicture', '请裁剪图片'), 'public.importsucceeded', '导入成功'), 'public.configuregoods', '配置商品'), 'public.configureDyx', '配置得意先'), "public.goonlinesuccess", "上线成功"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, "public.offlinesuccess", "下线成功"), "public.remind", "提醒：如果指定不参加商品列表为空，即为全部商品参加"), 'public.productisnull', '商品信息不完整，请完善后重试！'), 'public.customerisnull', '客户信息不完整，请完善后重试！'), 'public.open', '开启'), 'public.close', '关闭'), 'public.noPreview', '暂无法预览'), 'public.selectProduct', '选择商品'), 'public.selectDyx', '选择得意先'), 'public.selected2', '已选：商品'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, 'onSell', '上架'), 'offSell', '下架'), 'sellOver', '终卖'), 'overSell2', '取引终了'), 'selectAll', '全部页全选'), 'batchDelete', '批量删除'), 'public.home', '欢迎使用订货APP管理系统')),
    HK: {
      design: {
        name: '店鋪裝修',
        home: {
          name: '首頁裝修'
        }
      }
    },
    US: {
      design: {
        name: 'Shop Decoration',
        home: {
          name: 'Home Decoration'
        }
      }
    },
    JP: (_JP = {
      home: {
        name: 'ホーム'
      },
      design: {
        name: 'ストアデザイン',
        home: {
          name: 'ページデザイン'
        },
        designcategory: {
          name: 'モバイル版分類'
        }
      },
      affiliate: {
        name: '分销联盟',
        brokerage: {
          name: '佣金规则'
        },
        databoard: {
          name: '数据看板'
        },
        distribution: {
          name: '分销员管理'
        },
        settlementmanager: {
          name: '结算管理',
          settlement: {
            name: '结算管理'
          },
          order: {
            name: '订单明细'
          }
        },
        poster: {
          name: '海报规约'
        }
      },
      systemsetting: {
        name: 'システム設定',
        holidayset: {
          name: '休日設定'
        },
        basicsetting: {
          name: '基本設定',
          socialLogin: {
            columns: {
              thirdPlatforms: 'サードパーティープラットフォーム',
              messageNotify: 'メッセージ通知'
            },
            'wxParams1': 'クロスプラットフォームで統一されたアカウントに使用され、PC端末でWeChatスキャンログインに使用',
            'wxParams2': 'メッセージ通知に使用され、WeChatクライアント内でのログインに使用',
            wxParams3: 'モバイルアプリでWechatアカウントログインで利用する',
            notify: '通知',
            edit: '編集',
            decp: 'ドラッグ操作により並び順と番号を変更でき、表示順序に影響します。',
            wx: 'WeChat',
            qq: 'QQ',
            wb: '新浪微博',
            fb: 'FaceBook',
            line: 'Line',
            wxName1: 'PCウェブサイト',
            wxName2: '海外版WeChat公式アカウント',
            wxName3: '国内版WeChat公式アカウント',
            wxName4: 'Wechatモバイルアプリ',
            lineRule1: '入力してくださいChannel ID',
            lineRule2: '入力してくださいChannel Secret',
            lineMessage: 'Lineメッセージ通知を利用する場合は、Channel access tokenを入力してください',
            wxRule1: '入力してくださいApp ID',
            wxRule2: '入力してくださいSecret',
            wbRule1: '入力してくださいApp Key',
            wbRule2: '入力してくださいApp Serect',
            copy: 'コピー',
            open: 'オン',
            socialLogin: 'SNSアカウントログイン',
            look: 'チェック',
            link: 'リンク'
          }
        },
        deliveryChannelManagement: {
          name: '发货渠道管理'
        },
        deploy: {
          name: '環境設定'
        },
        hotwords: {
          name: 'ホットワード検索'
        },
        accountList: {
          name: 'アカウントリスト'
        }
      },
      freightmanager: {
        name: '配送管理',
        freightsetting: {
          name: '輸送日数設定'
        }
      },
      feesetting: {
        name: '货到付款手续费'
      },
      sendtypesetting: {
        name: '輸送方法設定'
      },
      cardrecommend: {
        name: '购物车推荐'
      },
      productList: {
        name: '商品リスト'
      },
      producDetail: {
        name: '商品詳細'
      },
      orderList: {
        name: "注文リスト"
      },
      orderDetail: {
        name: "注文詳細"
      },
      aftersaleslist: {
        name: "退换货列表"
      },
      articlemanagement: {
        name: "記事管理",
        article: {
          name: "記事リスト"
        },
        addArticle: {
          name: "新規記事登録"
        },
        editArticle: {
          name: "記事を編集"
        }
      },
      news: {
        name: '新着情報',
        add: {
          name: '新規新着情報登録'
        },
        edit: {
          name: '新着情報を編集'
        }
      },
      productmanager: {
        name: '商品管理',
        productmanager: {
          name: '商品管理'
        },
        productList: {
          name: '商品リスト'
        },
        sourcearea: {
          name: '原産地リスト'
        },
        brand: {
          name: 'ブランドリスト'
        },
        category: {
          name: '商品カテゴリー'
        },
        productNotice: {
          name: '入荷通知'
        },
        labelingManagement: {
          name: '商品タグ'
        },
        goodsGrouped: {
          name: '商品グループ'
        },
        goodsVisible: {
          name: '商品の可視性'
        },
        productDetail: {
          name: '商品詳細'
        }
      },
      productNotice: {
        list: {
          name: '入荷通知'
        },
        add: {
          name: '新規入荷通知'
        },
        edit: {
          name: '入荷通知を編集'
        }
      },
      goodsVisible: {
        list: {
          name: '商品の可視性'
        },
        addGoodsVisible: {
          name: '新規商品の可視性設定'
        },
        editGoodsVisible: {
          name: '商品の可視性設定の編集'
        }
      },
      goodsGrouped: {
        list: {
          name: '商品グループ'
        },
        addGoodsGrouped: {
          name: '商品グループの新規作成'
        },
        editGoodsGrouped: {
          name: '商品グループの編集'
        }
      },
      customermanager: {
        name: '得意先管理',
        customermanager: {
          name: '得意先リスト'
        },
        customerlist: {
          name: '得意先リスト'
        },
        editcustomer2: {
          name: '得意先を編集'
        },
        dyxDisGroup: {
          name: '得意先グループ'
        },
        captchaRecordList: {
          name: '認証コード送信記録'
        },
        contactUs: {
          name: '問い合わせ管理'
        }
      },
      dyxDisGroup: {
        adddyx: {
          name: '新規得意先グループを作成'
        },
        editdyx: {
          name: '得意先グループを編集'
        }
      },
      order: {
        name: '注文管理'
      },
      orderManager: {
        name: '注文リスト'
      },
      order2Manager: {
        name: '伝票リスト'
      },
      orderList2: {
        name: '伝票リスト'
      },
      orderDetail2: {
        name: "伝票詳細"
      },
      inquiryManager: {
        name: "見積依頼一覧"
      },
      inquiryList: {
        name: "見積依頼一覧"
      },
      inquiryDetail: {
        name: "見積依頼詳細"
      },
      quoteManager: {
        name: "見積書一覧"
      },
      quoteList: {
        name: '見積書一覧'
      },
      quoteDetail: {
        name: "見積書詳細"
      },
      areaManagement: {
        name: '納品先管理'
      },
      marketing: {
        name: 'マーケティング管理',
        activity: {
          name: 'キャンペーン管理',
          activityList: {
            name: 'キャンペーンリスト'
          },
          editActivity: {
            name: 'キャンペーンを編集'
          },
          lookActivity: {
            name: 'キャンペーンを見る'
          },
          addActivity: {
            name: '新規キャンペーン登録'
          }
        },
        searchKeyword: {
          name: "商品検索キーワード",
          searchKeywordList: {
            name: "商品検索キーワード一覧"
          },
          addSearchkeyword: {
            name: "新規商品検索キーワードの作成"
          },
          editSearchkeyword: {
            name: "商品検索キーワードの編集"
          }
        }
      },
      "public.public": '共通',
      'public.copyPromp': 'コピーしてもよろしいですか？',
      "publicuse.new": "新規作成",
      "publicuse.chtypeface": "简体",
      "publicuse.type": "类型",
      "publicuse.norestrictions": "不限制",
      "publicuse.status": "状態",
      "publicuse.updatetime": "更新時間",
      "publicuse.action": "操作",
      "publicuse.edit": "編集",
      "publicuse.delete": "削除",
      "publicuse.suerdelete": "削除してもよろしいですか？",
      "publicuse.onshelf": "有効にする",
      "publicuse.offshelf": "無効にする",
      "publicuse.more": "もっと",
      "publicuse.pleaseinput": "入力してください",
      "publicuse.inquire": "検索",
      "publicuse.inquire2": "検索（Enter）",
      "publicuse.pleaseselect": "選択してください",
      "publicuse.createdtime": "作成時間",
      "publicuse.putaway": "閉じる",
      "publicuse.unfold": "展開",
      "publicuse.translate": "翻訳",
      "publicuse.day": "天",
      "publicuse.goodsname": "商品名",
      "publicuse.goodsno": "商品コード",
      "publicuse.pricetax": "販売価格（税込）",
      "publicuse.add": "追加",
      "publicuse.addSuccess": "新規作成しました",
      "publicuse.stock": "在庫数",
      "publicuse.enable": "有効",
      "publicuse.disabled": "無効",
      "publicuse.no": "いいえ",
      "publicuse.yes": "はい",
      "publicuse.starttime": "開始時間",
      "publicuse.endtime": "終了時間",
      "publicuse.save": "保存",
      "publicuse.jpmoney": "円",
      "publicuse.stockQuantity": "在庫数",
      "publicuse.pleaseaddgoods": "请添加商品",
      "publicuse.cancel": "キャンセル",
      "publicuse.determine": "確定",
      "publicuse.fullcourt": "全商品",
      "publicuse.bycategory": "指定分类参加",
      "publicuse.byitem": "指定商品が参加",
      "publicuse.noparticipation": "指定商品が参加しない",
      "publicuse.classificationname": "分类名称",
      'publicuse.serialnumber': '序号',
      'publicuse.icon': '图标',
      'publicuse.name': '名称',
      'public.productName': '商品名',
      'public.enterPlease': '入力してください',
      'public.productNo': '商品コード',
      'public.productCategory': '商品カテゴリー',
      'public.skuNo': 'SKU编号',
      'public.sellPrice': '販売価格',
      'public.pleaseSelect': '選択してください',
      'public.Add': '追加',
      'public.save': '保存',
      'public.no': 'いいえ',
      'public.yes': 'はい',
      'public.saveSuccessfully': '保存成功',
      'public.add': '新規作成',
      'public.confirmPrompt': '确定要修改吗？',
      'public.sureStop': '停止しますか？',
      'public.sureEnable': '有効にしますか？',
      'public.deletePromp': '削除してもよろしいですか？'
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, "public.copyPromp", 'コピーしてもよろしいですか？'), 'public.copy', 'コピー'), 'public.confirm', '確定'), 'public.cancel', 'キャンセル'), 'public.cancelSuccessfully', '取消成功'), 'public.updateSuccessfully', '更新しました'), 'public.changeSuccessfully', '更新しました'), 'public.deleteSuccessfully', '削除しました'), 'public.addSuccessfully', '新規作成しました'), 'public.copySuccessfully', 'コピーしました'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, 'public.status', '状態'), 'public.updateTime', '更新時間'), 'public.operation', '操作'), 'public.enable', '有効'), 'public.disable', '無効'), 'public.edit', '編集'), 'public.delete', '削除'), 'public.uploadPicture', '画像をアップロード'), 'public.picture', '画像'), 'public.upload', 'アップロード'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, 'public.japanBrackets', '（日文）'), 'public.simpleWordBrackets', '（简体）'), 'public.traditionalBrackets', '（繁体）'), 'public.pictureType', 'JPGまたはPNG形式の画像のみアップロードできます'), 'public.pictureMax', 'アップロードする画像は{uploadLimit}MBを超えることはできません'), 'public.uploadPictureProp', '画像をアップロードしてください'), 'public.translate', '翻訳'), 'public.reminder', 'ヒント'), 'public.tip', '提示'), 'public.total', '総数'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, "public.disabledprop", '停止しますか？'), 'public.productInfo', '商品情報'), 'public.customerInfo', '客户信息'), "public.havetax", "（税込）"), 'public.importGoods', '导入商品'), 'public.remove', '移除'), 'public.sureremove', '确认移除吗？'), 'public.downloadTemplate', '下载模板'), 'public.lookData', 'チェック'), 'public.selected', '選択済み'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, 'public.term', '項目'), 'public.batchoperation', '一括処理'), 'public.batchremove', '批量移除'), 'public.checktheitem', '商品を選択'), 'public.currentpage', '現在のページ'), 'public.allpage', '全ページ'), 'public.syn', '同期'), 'public.nosyn', '不同步'), 'public.cancelremoval', '取消移除'), 'public.removalsucceeded', '移除成功'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, 'public.allproduct', '全商品'), 'public.yesproduct', '指定商品が参加'), 'public.noproduct', '指定商品が参加しない'), "public.invalid", "失效"), "public.sureinvalid", "确认要失效该商品吗？"), 'public.normal', '正常'), 'public.limitedsettings', '限购设置'), 'public.batchinvalid', '批量失效'), 'public.batchnumber', '批量设置参与件数'), 'public.discount', '折扣'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, 'public.more', 'もっと'), 'public.orderStatus1', '待支付'), 'public.orderStatus2', '処理待'), 'public.orderStatus3', '发货准备'), 'public.orderStatus4', '拣货中'), 'public.orderStatus5', '出荷済'), 'public.orderStatus6', '已完成'), 'public.orderStatus7', 'キャンセル済'), 'public.orderStatus8', '已返品'), 'public.orderStatus9', '注文受付'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, 'public.expressStatus0', '集荷待ち'), 'public.expressStatus1', '集荷済み'), 'public.expressStatus2', '配送中'), 'public.expressStatus3', '受け取り済み'), 'public.expressStatus4', '再配送'), 'public.expressStatus5', '問題が発生しました'), 'public.orderStatus99', '処理済'), 'public.arriveItem0', '指定なし'), 'public.arriveItem1', '午前中'), 'public.arriveItem2', '14:00~16:00'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, 'public.arriveItem3', '16:00~18:00'), 'public.arriveItem4', '18:00~20:00'), 'public.arriveItem5', '19:00~21:00'), 'public.exportpromptone', 'インポートテンプレートはxls、xlsx形式のみです！'), 'public.exportprompytwo', 'インポートテンプレートのサイズは10MBを超えることはできません！'), 'public.importfiledproduct', '导入失败商品列表'), 'public.failurereason', '失敗原因'), 'public.notontheshelf', '未上架'), 'public.deleted', '已删除'), 'public.disposals', '特卖品'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, 'public.nonexistent', '不存在'), 'public.overSell', '終売'), 'public.overSellPromp', '終売してもよろしいですか？'), 'public.success', '成功'), 'public.fail', '失敗'), 'public.addfail', '新建失败，请联系管理员！'), 'public.individual', '个'), 'public.importfail', '导入失败，请联系管理员！'), 'public.specialoffer', '特价'), 'public.multiple', '倍数'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, 'public.previousstep', '前へ'), 'public.nextstep', '次へ'), 'public.addsuccee', '完了'), 'public.newagain', '再作成'), 'public.returntolist', 'リストに戻る'), 'public.pleaseCropThePicture', '请裁剪图片'), 'public.importsucceeded', 'インポート成功'), 'public.configuregoods', '商品指定'), 'public.configureDyx', '得意先指定'), "public.goonlinesuccess", "有効にしました"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, "public.offlinesuccess", "無効にしました"), "public.remind", "指定された商品がない場合は、全ての商品が参加します"), 'public.productisnull', '商品信息不完整，请完善后重试！'), 'public.customerisnull', '客户信息不完整，请完善后重试！'), 'public.open', 'オン'), 'public.close', 'オフ'), 'public.noPreview', 'プレビューできません'), 'public.selectProduct', '商品を選択'), 'public.selectDyx', '得意先を選択'), 'public.selected2', '選択済み：商品'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, 'onSell', '販売開始'), 'offSell', '販売停止'), 'sellOver', '終売'), 'overSell2', '取引終了'), 'selectAll', '全ページを全選択'), 'batchDelete', '一括削除'), 'public.home', '注文APP管理システムをご利用いただき、ありがとうございます'))
  }
};